<template>
  <div>
    <div v-if="location.geocoding">
      {{ i18n.t('components.location_editor.geocoding_in_progress') }}
    </div>
    <div v-else>
      <img v-if="hasCoordinates && !location.geocoding" class="map" :src="mapUrl">
      <div v-if="location.geocode_failed" class="is-invalid">
        <span class="invalid-feedback d-block">{{ i18n.t('components.location_editor.geocode_failed') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true
    }
  },
  computed: {
    baseStaticMapUrl() {
      const tokyoHost = window.Agra.Configuration.tokyoUrlBase
      return `${tokyoHost}/maps/staticmap`
    },

    hasCoordinates() {
      return this.location.latitude !== null && this.location.longitude !== null
    },

    mapUrl() {
      if (!this.hasCoordinates) { return }

      const url = new URL(this.baseStaticMapUrl)
      const coordinates = `${this.location.latitude},${this.location.longitude}`
      const searchParams = new URLSearchParams({
        center: coordinates,
        markers: coordinates,
        zoom: 14,
        size: '250x250'
      })
      url.search = searchParams.toString()

      return url.toString()
    }
  }
}
</script>
